module.exports = __webpack_public_path__ + "static/media/network.f47ddeba.svg";